import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet } from "../api/client";

interface Regulation {
  id: string;
  title: string;
  kind: string;
  jurisdiction: string;
  issued_at: string;
  status: string;
  source_url: string | null;
  meta: Record<string, string>;
}

export default function Dashboard() {
  const [regs, setRegs] = useState<Regulation[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGet<Regulation[]>("/regulations").then((r) => {
      setRegs(r);
      setLoading(false);
    });
  }, []);

  const card = (r: Regulation) => (
    <Link
      to={`/regulations/${r.id}`}
      className="block rounded-lg border border-border p-4 hover:bg-surface transition"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <h2 className="text-sm font-semibold text-text">{r.title}</h2>
          <p className="mt-1 text-xs text-muted">
            {r.kind} · {r.jurisdiction} · {r.issued_at || "TTD"}
          </p>
        </div>
        <span className="rounded-full bg-primary-500 px-2 py-0.5 text-[11px] font-semibold text-white">
          {r.status}
        </span>
      </div>
      <p className="mt-2 line-clamp-2 text-xs text-muted">{r.meta?.scope || "scope tersembunyi"}</p>
    </Link>
  );

  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-text">Dashboard</h2>
        <Link to="/topics" className="text-sm text-primary hover:underline">
          Buka Topik ⇢
        </Link>
      </div>

      {loading ? (
        <div className="mt-4 space-y-3">
          {Array.from({ length: 4 }, (_, i) => (
            <div key={i} className="h-24 animate-pulse rounded border border-border" />
          ))}
        </div>
      ) : regs.length === 0 ? (
        <div className="mt-4 rounded border border-dashed border-border p-12 text-center text-muted">
          Belum ada regulasi. Impor CSV pertama Anda.
        </div>
      ) : (
        <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {regs.map(card)}
        </div>
      )}
    </div>
  );
}
